import { h } from 'preact';
import capitalize from '../utils/capitalize';
import apiConfig from '../../config/apiConfig';

function SignInWithItem ({ name, href = '', onSelect }) {
  const onClick = () => onSelect(capitalize(name));

  return (
    <a className="social-button-item" href={href} onClick={onClick}>
      <i className={`social-button-${name}`} />
      <p className="social-button-label">
        {'Iniciar con '}
        <span>{name}</span>
      </p>
    </a>
  );
}

export default function SignInWith ({ onSelect }) {
  return (
    <div>
      <div className="or">
        <hr className="bar" />
        <span>O</span>
        <hr className="bar" />
      </div>
      <div className="social-button">
        <SignInWithItem
          onSelect={onSelect}
          name="facebook"
          href={`${apiConfig.root}/auth/facebook`}
        />
        <SignInWithItem
          onSelect={onSelect}
          name="google"
          href={`${apiConfig.root}/auth/google_oauth2`}
        />
        <SignInWithItem
          onSelect={onSelect}
          name="outlook"
          href={`${apiConfig.root}/auth/microsoft_v2_auth`}
        />
      </div>
      <div className="or">
        <hr className="bar" />
        <span>O</span>
        <hr className="bar" />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/SignInWith.js